import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
} from "./../../components/card/card.jsx";
import "react-quill/dist/quill.snow.css";
import { useParams } from "react-router-dom";
import { machineProfile, sensor } from "../../api";
import LiveChart from "./LiveChart";
import {
  renderImage,
  printDate,
  printLocation,
  formatDateOnly,
} from "../../utils/helper";
import { useAuth } from "../../contexts/AuthContext";
import ImageViewer from "../../components/ImageViewer";
import LoadingIndicator from "../../components/LoadingIndicator";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import DataTable from "react-data-table-component";
import { useDashboardContext } from "../../contexts/NewDashboardContext";

function PageMachineProfile({ machineId }) {
  const { selectAnnotation, refreshAnnotation } = useDashboardContext();
  const [allAnnotation, setAllAnnotation] = useState([]);
  const [selectedAnnotation, setSelectedAnnotation] = useState(null);
  const { getLocationName, email } = useAuth();
  const [machine, setMachine] = useState(null);
  const [loading, setLoading] = useState(true);
  const [locations, setLocations] = useState([]);
  const [key, setKey] = useState("tab0");
  useEffect(() => {
    if (machine) {
      const locationName = [];
      function generateLocation(location) {
        locationName.push(location.location_name);
        if (location.parent_location) {
          generateLocation(location.parent_location);
        }
      }

      generateLocation(machine.location);
      setLocations(locationName.reverse());
    }
  }, [machine]);
  const getMachine = async () => {
    try {
      setLoading(true);
      const res = await machineProfile.getOne(machineId);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        setMachine(data);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getMachine();
    getAnnotation();
  }, [machineId]);

  useEffect(() => {
    getAnnotation();
  }, [refreshAnnotation]);

  const getAnnotation = async () => {
    const result = await sensor.getAnnotationMachine({
      machine_id: machineId,
    });
    if (result.ok) {
      const body = await result.json();
      let data = body.data;
      setAllAnnotation(data);
    }
  };

  const getSensors = () => {
    const sensors = [];
    if (machine && machine.machine_elements) {
      machine.machine_elements.map((me) => {
        if (me.deployments) {
          me.deployments.map((d) => {
            let sensor = d.sensor;
            sensor.machine_element_name = me.machine_element_name;
            sensor.machine_element_id = me.id;
            sensor.deployments_id = d.id;
            sensors.push(sensor);
          });
        }
      });
    }
    //console.log({ sensors });
    return sensors;
  };
  const ExpandedComponent = ({ data }) => {
    return (
      <div style={{ padding: "10px" }}>
        <Card className="border-theme">
          <CardBody>
            <div>
              <table className="table table-sm">
                <tr>
                  <td>Chart Type</td>
                  <td>:</td>
                  <td>{data.chart_type}</td>
                </tr>
                <tr>
                  <td>Timestamp</td>
                  <td>:</td>
                  <td>{data.timestamp}</td>
                </tr>
                <tr>
                  <td>Updated By</td>
                  <td>:</td>
                  <td>{data.updated_by}</td>
                </tr>
                <tr>
                  <td>Type</td>
                  <td>:</td>
                  <td>{data.annotation_type}</td>
                </tr>
                <tr>
                  <td>Annotation</td>
                  <td>:</td>
                  <td>{data.annotation}</td>
                </tr>
                <tr>
                  <td>Element</td>
                  <td>:</td>
                  <td>
                    {data.deployment?.machine_element?.machine_element_name}
                  </td>
                </tr>
              </table>
              <button
                onClick={() => viewAnnotation(data)}
                className="btn mt-3 btn-sm btn-outline-theme"
              >
                View Annotation
              </button>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  };

  const viewAnnotation = (data) => {
    const sensorId = data?.deployment?.sensor_id;
    const listSensor = getSensors();
    const filter = listSensor.findIndex((s) => s.internal_id === sensorId);

    if (filter !== -1) {
      setKey("tab" + filter);
      const sensorData = listSensor[filter];
      setSelectedAnnotation(data);
      selectAnnotation(data);
    }
  };

  const columns = [
    {
      name: "Type",
      width: "70px",
      selector: (row) => row.annotation_type,
    },
    {
      name: "Timestamp",
      selector: (row) => row.timestamp,
    },
    {
      name: "Element",
      selector: (row) => row.deployment?.machine_element?.machine_element_name,
    },
  ];

  return (
    <div>
      <LoadingIndicator open={loading} />
      <div className="row gx-4">
        <div className="col-lg-12">
          <Card className="mb-4">
            <CardHeader>Live Sensor Data</CardHeader>
            <CardBody>
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3"
              >
                {getSensors().map((item, index) => {
                  return (
                    <Tab
                      eventKey={"tab" + index}
                      title={item.machine_element_name}
                    >
                      {/*        /!*only render if key are active*!/*/}
                      {key == "tab" + index && (
                        <LiveChart
                            hideSpectrogram={true}
                          sensorData={item}
                          machineId={machineId}
                          machineDetail={machine}
                        />
                      )}
                    </Tab>
                  );
                })}
              </Tabs>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default PageMachineProfile;
